import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import './utils/imageHandler';
import lightbox2 from 'lightbox2';
import smoothstate from 'smoothstate';
import onReady from './utils/onReady';
import bootstrapper from './utils/bootstrapper';
import HeaderSlider from './modules/header-slider';
import HorizontalSlider from './modules/horizontal-slider';
import MainMenu from './modules/main-menu';
import StickyHeader from './modules/sticky-header';
import ProjectFiltering from './modules/project-filtering';
import ShowOnScroll from './modules/show-on-scroll';
import VerticalSlider from './modules/vertical-slider';
import TextBlockFolding from './modules/text-block-folding';
import ScrollToNavigation from './modules/scroll-to-navigation';
import TextBlockColsExpand from './modules/text-block-cols-expand';
import HorizontalSliderVariableWidth from './modules/horizontal-slider-variable-width';

window.$ = $;

// Bootstrap the modules. You can add as many modules as you want, as indicated by the commented lines.
// Please do not make multiple calls to bootstrapper()! One call with all the references will be MUCH faster.
// For more information, and alternate bootstrapping methods, look inside bootstrapper.js and check out the
// various exported methods.

function runApp() {
    const url = window.location.pathname;

    //If we are on aktuelt page or a single aktuelt item, dont remove localstoage on current slide item
    if(url.includes("aktuelt") || url.includes("currently")) {
        //Keep localstorage...
    } else {
        localStorage.removeItem("currentSlideItem");
    }

    bootstrapper({
        'header-slider': HeaderSlider,
        'horizontal-slider': HorizontalSlider,
        'main-menu': MainMenu,
        //'sticky-header': StickyHeader,
        'project-filtering': ProjectFiltering,
        'vertical-slider': VerticalSlider,
        'text-block-folding': TextBlockFolding,
        'scroll-to-navigation': ScrollToNavigation,
        'text-box-cols-expand': TextBlockColsExpand,
        'horizontal-slider-variable-width': HorizontalSliderVariableWidth
    });

    const showonscroll = new ShowOnScroll();

    onReady(svg4everybody, 150);

    let scroll_to_top = $(".scroll-to-top");

    scroll_to_top.click(function(event) {
        event.preventDefault();
        $("html, body").animate({ scrollTop: 0 }, "fast");
        return false;
    });
}

var $page = $('#app'),
    options = {
        anchors: '.main-menu-navigation a',
        debug: false, //disable when in production
        prefetch: true,
        prefetchOn: 'mouseover touchstart',
        cacheLength: 6,
        repeatDelay: 500,
        scroll: true,
        blacklist : "form",
        forms: '.smoothstate-form',
        allowFormCaching: false,
        onStart: {
            duration: 500, // Duration of our animation
            render: function ($container) {
                // Add your CSS animation reversing class
                $container.addClass('is-exiting');
                $("body").addClass('is-exiting');
                // Restart your animation
                smoothState.restartCSSAnimations();
            }
        },
        onReady: {
            duration: 0,
            render: function ($container, $newContent) {
                // Remove your CSS animation reversing class
                $container.removeClass('is-exiting');
                $("body").removeClass('is-exiting');
                // Inject the new content
                $container.html($newContent);
                runApp();
            }
        }
    },
    smoothState = $page.smoothState(options).data('smoothState');

// Run svg4everybody at low priority, giving our own modules time to instantiate first.
onReady(runApp);